import { AllType, RoutePath } from "src/data/Routes";
import { GLOB } from "src/util/Glob";
import { buildPathUrl, PathUrlDeps } from "./buildPathUrl";
import { findNavDomain } from "./domain";

/**
 * Storage devices tree URL segments use the device title — maps it back to the hwType path the
 * menu API expects.
 */
function getStorageDeviceHwTypePath(typeOrDevicePath: string): string {
  const typeOrDevice = typeOrDevicePath?.substring(1);
  const dev = GLOB.menuService.storagesBy.device.children.find(mn => mn.title === typeOrDevice);
  return dev ? '/' + dev.hwType : typeOrDevicePath;
}

export const globPathUrlDeps: PathUrlDeps = {
  storageDeviceHwTypePath: getStorageDeviceHwTypePath,
  navDomainPathUrl: (clsPath, itemSearch) => findNavDomain(clsPath)?.pathUrl?.(itemSearch),
};

/** Menu URL resolving an item's path, wired to the loaded menu and the domain registry. */
export function getPathUrl(clsPath: RoutePath, allType: AllType, groupId: string, typeOrDevicePath: string,
  itemSearch: string): string {
  return buildPathUrl({ clsPath, allType, groupId, typeOrDevicePath, itemSearch }, globPathUrlDeps);
}
